import { forwardRef } from "react";
import classes from "./Checkbox.module.scss";

import classNames from "classnames";
import PropTypes from "prop-types";
import { v4 as uuidv4 } from "uuid";

export const Checkbox = forwardRef(
  (
    { label, name, defaultChecked, onChange, checked, error, ...props },
    ref
  ) => {
    const checkboxId = uuidv4();
    return (
      <div
        className={classNames(classes["wrapper"], {
          [classes["error"]]: !!error,
        })}
      >
        <input
          type="checkbox"
          name={name}
          defaultChecked={defaultChecked}
          checked={checked}
          id={checkboxId}
          className={classes["checkbox"]}
          ref={ref}
          onChange={onChange || undefined}
          {...props}
        />

        <label htmlFor={checkboxId} className={classes["label-wrapper"]}>
          <div
            className={`${classes["checkbox-label"]}`}
            data-testid={"checkbox-label"}
          >
            <span className={`${classes["icon"]} icon-check`} />
          </div>
          <div className={classes["label-text"]}>{label}</div>
        </label>
        {!!error && <span className="text-red">{error}</span>}
      </div>
    );
  }
);

Checkbox.propTypes = {
  /**
   * Checkbox label (Any React/HTML node)
   */
  label: PropTypes.node,
  /**
   * name of input tag
   */
  name: PropTypes.string,
  //TODO: handle additional props and test them
};

Checkbox.defaultProps = {
  label: "",
};
